import type { TourDefinition } from './types'

export const COACH_TOUR_ID = 'coach'
export const COACH_TOUR_VERSION = 5

export const COACH_TOUR: TourDefinition = {
  id: COACH_TOUR_ID,
  version: COACH_TOUR_VERSION,
  copyKey: 'coach',
  hasWelcome: true,
  autoStart: ({ user }) => !!user?.hasTrainees,
  steps: [
    {
      id: 'today-overview',
      path: '/',
      target: 'tour-today-overview',
      titleKey: 'todayTitle',
      bodyKey: 'todayBody',
      iconId: 'today',
    },
    {
      id: 'clients',
      path: '/',
      target: 'tour-clients',
      titleKey: 'clientsTitle',
      bodyKey: 'clientsBody',
      iconId: 'clients',
    },
    {
      id: 'more-clients',
      path: '/more',
      target: 'tour-more-clients',
      titleKey: 'moreTitle',
      bodyKey: 'moreBody',
      iconId: 'more',
    },
    {
      id: 'assistant',
      path: '/more',
      target: 'tour-more-assistant',
      titleKey: 'assistantTitle',
      bodyKey: 'assistantBody',
      iconId: 'assistant',
      tipPlacement: 'above',
    },
  ],
}

/** @deprecated Use COACH_TOUR / registry */
export const TMA_TOUR_VERSION = COACH_TOUR_VERSION
/** @deprecated Use COACH_TOUR.steps */
export const COACH_TOUR_STEPS = COACH_TOUR.steps
